import get from 'lodash/get';
import clone from 'lodash/clone';
import Ncs from '../index';
export default {
  namespaced: true,
  state: {
    groups: []
  },
  mutations: {
    setGroups: function setGroups(s, g) {
      s.groups = clone(g);
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      s.groups = v.groups;
    }
  },
  getters: {
    snapshot: function snapshot(s) {
      return s;
    },
    query: function query(s) {
      return s.groups;
    },
    options: function options(s, g, rs, rg) {
      var formResultType = rg['api/formResultType'];
      var elementType = rs.elements.type;
      return get(Ncs.config.result, [formResultType, elementType, 'groups'], []);
    }
  },
  actions: {
    setDefault: function setDefault(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters,
          rootGetters = _ref.rootGetters,
          rootState = _ref.rootState;
      var formResultType = rootGetters['api/formResultType'];
      var elementType = rootState.elements.type;
      var defaultGroups = get(Ncs.config.result, [formResultType, elementType, 'defaultGroups'], []);
      commit('setGroups', defaultGroups);
    },
    reset: function reset(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters,
          rootState = _ref2.rootState;
      dispatch('setDefault');
    }
  }
};